import { Tabs } from "antd";
import React from "react";

import BannerProduct from "./BannerProduct";
import SliderProduct from "../../pages/Modules/SliderProduct";
import SliderCenter from "../../pages/Modules/SliderCenterHome";
import SliderDiscount from "../../pages/Modules/SliderDiscount";
import HomeIntroduction from "./HomeIntroduction";
import BannerTop from "../../pages/Modules/BannerTop";

const Home = (props) => {
  const { TabPane } = Tabs;

  return (
    <Tabs defaultActiveKey="1">
      <TabPane tab="Banner đầu trang" key="1">
        <BannerTop />
      </TabPane>
      <TabPane tab="Slider sản phẩm nổi bật" key="2">
        <SliderProduct />
      </TabPane>

      <TabPane tab="Banner trang chủ" key="3">
        <SliderCenter />
      </TabPane>
      {/* <TabPane tab="Section sản phẩm khuyến mãi" key="4">
        <SliderDiscount />
      </TabPane> */}
      <TabPane tab="Sản phẩm nổi bật" key="5">
        <BannerProduct />
      </TabPane>
      <TabPane tab="Giới thiệu" key="6">
        <HomeIntroduction />
      </TabPane>
    </Tabs>
  );
};

export default Home;
